<template>
  <div class="popup" v-cloak v-if="deleteShow">
    <div class="content" id="delete">
      <div class="title">
        <span>{{ $t('language.common.delete') }}</span>
        <div class="icon white-close dialog-close" @click="deleteShow = false"></div>
      </div>
      <div style="line-height: 20px;padding: 25px 20px;" class="delete-content" v-if="$route.query.cloudType == 'outlook'">
        <span v-html="$t('language.popup.cloudExploerPopup.deleteContentEver')"></span>
      </div>
      <div class="delete-content" v-else>
        <span>{{ $t('language.popup.cloudExploerPopup.deleteContent') }}</span>
      </div>
      <div class="delete-footer">
        <button style="float:right;" @click="deleteItemsStart">{{ $t('language.common.delete') }}({{
          deleteList.length }})</button>
      </div>
    </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
  data: function () {
    return {
      deleteShow: false,
      deleteList: '',
      flag: true
    }
  },
  methods: {
    //开始删除
    deleteItemsStart() {
      this.deleteShow = false;
      if (this.flag) {
        let allData = Object.assign([], this.$parent.selectItemArr);
            if(this.$route.name == 'cloudExploer'){
        this.deleteItems(allData);
            }else if(this.$route.name == 'emailExploer'){
              this.deleteEmails(allData);
      }
          }
    },
    //正则判断wasabi的桶是不是纯数字
    checkNumberBuket(item) {
      var reg = /^[0-9]*$/;
      return reg.test(item);
    },
    //删除项
    deleteItems(allData) {
      let that = this;
      let deleteData;
      if (allData.length >= 1) {
        this.flag = false;
        if (this.$route.query.cloudType == 'wasabi' && this.$route.query.folderId == 'root0' && that.checkNumberBuket(
          allData[0].name)) {
          that.$toast({
            text: that.$t('language.cloudExploer.deleteBucket'),
            type: 'fail',
            idValue: "rightBo",
          });
          return;
        }
        if (this.$route.query.folderId != 'recycle_bin' && (this.$route.query.cloudType == 'google_drive' || this.$route.query.cloudType == 'iCloudDrive')) {
          deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, allData[0].driveId,
            allData[0].pid, allData[0].dir, false);
          } else if (this.$route.query.folderId == 'recycle_bin'||this.$route.query.folderId == 'category:Trash' || this.$route.query.folderId == 'category:Recently Deleted') { //如果是删除回收站数据
            deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, this.$route.query.tokenId,
              this.$route.query.folderId, allData[0].dir, true);
        } else if (this.$route.query.folderId != 'recycle_bin' && (this.$route.query.cloudType != 'google_drive' || this.$route.query.cloudType != 'iCloudDrive')) {
          deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, allData[0].driveId,
              allData[0].pid, allData[0].dir, false);
        }
        that.Utils.doFilesRequest("delete", deleteData).then(res => {
          if (res.status == 200) {
            // 更新前端页面的数据，实现局部刷新
            const deletedItemId = allData[0].id;
            // 找到存储回收站数据的数组或对象
            const tableData = that.$parent.tableData;
            // 使用splice方法或delete关键字删除对应的数据项
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].id === deletedItemId) {
                tableData.splice(i, 1); // 从数组中删除对应的数据项
                break;
              }
            }
            // 修复：回收站删除文件后，已选择计数不减
            that.$parent.selectItemArr = that.$parent.selectItemArr.filter(function (ele) {
              return ele.id != deletedItemId;
            });
            if (that.$store.state.cutArr.length) {
              that.deleteCutOrCopyArrLength(allData[0].id, that.$store.state.cutArr);
              that.$store.state.cutClonArr = Object.assign([], that.$store.state.cutArr);
            }
            if (that.$store.state.copyArr.length) {
              that.deleteCutOrCopyArrLength(allData[0].id, that.$store.state.copyArr);
            }
            that.$parent.tableData.some((item, j) => { //将未删除数据加入缓存
              if (item.id == allData[0].id && allData[0].driveId == this.$route.query.tokenId) {
                let key = allData[0].id + that.$route.query.tokenId;
                let allStoreData = that.$store.state.cacheTableDatas;
                if (that.$store.state.cacheTableDatas[key]) {
                  delete that.$store.state.cacheTableDatas[key];
                }
                that.$parent.tableData.splice(j, 1);
                if (that.$route.query.folderId != 'recycle_bin') {
                  that.commitTrashData(item); //缓存回收站数据
                }
                //如果是备份目录下，则不再缓存
                if (!commonUtils.pathExcludeBackupRoot(that.$parent.pathJson)) {
                  that.$store.commit("setCacheTableDatas", {
                    id: deleteData.pid + deleteData.dd,
                    tableData: that.$parent.tableData
                  });
                }
                //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
                return true;
              }
            });
            that.$parent.selectItemArr.some((item2, k) => {
              if (item2 && item2.id && (item2.id == allData[0].id) && allData[0].driveId == this.$route.query
                .tokenId) {
                that.$parent.selectItemArr.splice(k, 1); //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
                return true;
              }
            });
            allData.splice(0, 1);
            that.deleteItems(allData); //执行下一个删除项
          } else {
            that.flag = true;
            that.$toast({
              text: that.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBo",
            });
          }
        });
      } else {
        this.$parent.$forceUpdate();
        this.flag = true;
        if (this.$route.query.folderId != 'recycle_bin') {
          let listData = new cloudExploerUtils.filelistData(this.$route.query.folderId, JSON.parse(localStorage
            .getItem("user")).id, this.$route.query.tokenId);
          commonUtils.refreshTreeData(listData, this.$route.query.cloudType, null, this.$parent, function (res) { });
        } else {
          that.$parent.trashRequestNoLoad();
        }

      }
    },
      //删除邮件会话
      deleteEmails(allData) {
        let that = this;
        let deleteData;
        if (allData.length >= 1) {
          this.flag = false;
          if (this.$route.query.folderId != 'category:Trash' && this.$route.query.cloudType == 'gmail') {
            deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, allData[0].driveId,
              allData[0].pid, allData[0].dir, false);
          } else if (this.$route.query.folderId == 'recycle_bin'||this.$route.query.folderId == 'category:Trash') { //如果是删除回收站数据
            deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, this.$route.query.tokenId,
              this.$route.query.folderId, allData[0].dir, true);
          } else if (this.$route.query.folderId != 'recycle_bin' && this.$route.query.cloudType != 'gmail') {
            deleteData = new cloudExploerUtils.deleteData(allData[0].id, commonstate.user.id, allData[0].driveId,
              allData[0].pid, allData[0].dir, true);
          }
          //gmail用id
          if(allData[0].threadId){
            deleteData.threadId = allData[0].threadId;
          }
          that.Utils.doCloudEmailRequest("delete", deleteData).then(res => {
            if (res.status == 200) {
              if (that.$store.state.cutArr.length) {
                that.deleteCutOrCopyArrLength(allData[0].id, that.$store.state.cutArr);
                that.$store.state.cutClonArr = Object.assign([], that.$store.state.cutArr);
              }
              if (that.$store.state.copyArr.length) {
                that.deleteCutOrCopyArrLength(allData[0].id, that.$store.state.copyArr);
              }
              that.$parent.tableData.some((item, j) => { //将未删除数据加入缓存
                if (item.id == allData[0].id && allData[0].driveId == this.$route.query.tokenId) {
                  let key = allData[0].id + that.$route.query.tokenId;
                  // let allStoreData = that.$store.state.cacheTableDatas;
                  if (that.$store.state.cacheTableDatas[key]) {
                    delete that.$store.state.cacheTableDatas[key];
                  }
                  that.$parent.tableData.splice(j, 1);
                  if (that.$route.query.folderId != 'recycle_bin') {
                    that.commitTrashData(item); //缓存回收站数据
                  }
                  //如果是备份目录下，则不再缓存
                  // if (!commonUtils.pathExcludeBackupRoot(that.$parent.pathJson)) {
                  //   that.$store.commit("setCacheTableDatas", {
                  //     id: deleteData.pid + deleteData.dd,
                  //     tableData: that.$parent.tableData
                  //   });
                  // }
                  //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
                  return true;
                }
              });
              that.$parent.selectItemArr.some((item2, k) => {
                if (item2 && item2.id && (item2.id == allData[0].id) && allData[0].driveId == this.$route.query
                  .tokenId) {
                  that.$parent.selectItemArr.splice(k, 1); //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
                  return true;
                }
              });
              allData.splice(0, 1);
              that.deleteEmails(allData); //执行下一个删除项
            } else {
              that.flag = true;
              that.$toast({
                text: that.$t('language.exception.' + res.reason),
                type: 'fail',
                idValue: "rightBo",
              });
            }
          });
        } else {
          this.$parent.$forceUpdate();
          this.flag = true;
          if (this.$route.query.folderId != 'recycle_bin') {
            let listData = new cloudExploerUtils.filelistData(this.$route.query.folderId, JSON.parse(localStorage
              .getItem("user")).id, this.$route.query.tokenId);
            commonUtils.refreshTreeDataFromEmail(listData, this.$route.query.cloudType, null, this.$parent, function(res) {});
          } else {
            that.$parent.trashRequestNoLoad();
          }

        }
      },
    //缓存回收站数据
    commitTrashData(item) {
      let id = 'recycle_bin' + this.$route.query.tokenId;
      if (this.$store.state.cacheTableDatas[id]) {
        let tableData = this.$store.state.cacheTableDatas[id].tableData;
        tableData.push(item);
        tableData = commonUtils.sortArr(tableData, this.$parent.upShow, this.$parent.index);
        this.$store.commit("setCacheTableDatas", {
          id: id,
          tableData: tableData
        });
      }
    },
    deleteCutOrCopyArrLength(id, arr) {
      $.each(arr, function (i, item) {
        if (item.id == id) {
          arr.splice(i, 1);
          i--;
        }
      });

    }
  }
}
</script>

<style>
#delete {
  width: 500px;
  /*no*/
  height: 180px;
  /*no*/
}

.delete-content {
  width: 100%;
  /*no*/
  height: 90px;
  /*no*/
  font-size: 14px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  /*no*/
  line-height: 90px;
  /*no*/

}

.delete-footer {
  width: 100%;
  height: 48px;
  /*no*/
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/delete_popup.vue